export default __webpack_public_path__ + "images/Blog1.png";